import React from "react";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import Profile from "./Profile";

function Header({ user, isAuthenticated }) {
  return (
    <div className="header">
      <LoginButton />
      <LogoutButton />
      <Profile user={user} isAuthenticated={isAuthenticated} />
    </div>
  );
}

export default Header;
